import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';
import { INIT, LOADING, SUCCESS, ERROR, AUTH_STATES } from '../../utils/constants';
import { requestClientTokenAPI, loginAPI, refreshTokenAPI, logoutAPI } from './api';

import { setClientToken, setUserToken, getUserToken, removeUserToken } from '../../utils/helpers';

export const GET_CLIENT_TOKEN = 'advaice/oauth/GET_CLIENT_TOKEN';
export const GET_CLIENT_TOKEN_SUCCESS = 'advaice/oauth/GET_CLIENT_TOKEN_SUCCESS';
export const GET_CLIENT_TOKEN_ERROR = 'advaice/oauth/GET_CLIENT_TOKEN_ERROR';

export const LOGIN = 'advaice/oauth/LOGIN';
export const LOGIN_SUCCESS = 'advaice/oauth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'advaice/oauth/LOGIN_ERROR';
// using this action, when we don't need request server for resolving error. For
// example, user has been notified about error and fix or cancel this error.
export const ANNUL_USER_TOKEN_ERROR = 'advaice/oauth/ANNUL_USER_TOKEN_ERROR';

// do this, for example, when user logged after registration or after social for
// save time and get rid of the need to do additional request;
export const EXTERNAL_LOGIN = 'advaice/oauth/EXTERNAL_LOGIN';

export const IS_AUTHORIZED = 'advaice/oauth/IS_AUTHORIZED';
export const NOT_AUTHORIZED = 'advaice/oauth/NOT_AUTHORIZED';
export const IS_AUTHORIZED_SUCCESS = 'advaice/oauth/IS_AUTHORIZED_SUCCESS';
export const IS_AUTHORIZED_ERROR = 'advaice/oauth/IS_AUTHORIZED_ERROR';

export const LOGOUT = 'advaice/oauth/LOGOUT';
export const LOGOUT_SUCCESS = 'advaice/oauth/LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'advaice/oauth/LOGOUT_ERROR';


const initialState = {
  status: INIT,
  clientToken: '',
  userToken: {
    accessToken: '',
    refreshToken: '',
    scope: '',
  },
  isAuthorized: INIT,
  error: '',
};

export const oauthStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_CLIENT_TOKEN:
      return {
        ...state,
        status: LOADING,
        error: '',
      };
    case GET_CLIENT_TOKEN_SUCCESS:
      return {
        ...state,
        clientToken: action.payload,
        status: SUCCESS,
      };
    case GET_CLIENT_TOKEN_ERROR:
      return {
        ...state,
        error: action.payload,
        status: ERROR,
      };
    case LOGIN:
      return {
        ...state,
        status: LOADING,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        status: SUCCESS,
        userToken: {
          ...state.userToken,
          accessToken: action.payload.access_token,
          refreshToken: action.payload.refresh_token,
          scope: action.payload.scope,
        },
        isAuthorized: AUTH_STATES.AUTH,
      };
    case EXTERNAL_LOGIN:
    {
      return {
        ...state,
        status: SUCCESS,
        userToken: {
          ...state.userToken,
          accessToken: action.payload.access_token,
          refreshToken: action.payload.refresh_token,
          scope: action.payload.scope,
        },
        isAuthorized: AUTH_STATES.AUTH,
      };
    }

    case LOGIN_ERROR:
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    case ANNUL_USER_TOKEN_ERROR:
      return {
        ...state,
        status: INIT,
        error: '',
      };
    case IS_AUTHORIZED:
      return {
        ...state,
        status: LOADING,
      };
    case IS_AUTHORIZED_SUCCESS:
      return {
        ...state,
        status: SUCCESS,
        userToken: {
          ...state.userToken,
          accessToken: action.payload.access_token,
          refreshToken: action.payload.refresh_token,
          scope: action.payload.scope,
        },
        isAuthorized: AUTH_STATES.AUTH,
      };
    case NOT_AUTHORIZED:
    {
      return {
        ...state,
        status: SUCCESS,
        isAuthorized: AUTH_STATES.DEAUTH,
      };
    }
    case LOGOUT:
    {
      return {
        ...state,
        status: LOADING,
        clientToken: '',
        userToken: {
          ...state.userToken,
          accessToken: '',
          refreshToken: '',
          scope: '',
        },
        isAuthorized: AUTH_STATES.DEAUTH,
        error: '',
      };
    }
    case LOGOUT_SUCCESS:
    {
      window.location.reload();
      return {
        ...state,
        status: LOADING,
      };
    }
    case LOGOUT_ERROR:
    {
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };
    }
    default:
    {
      return state;
    }
  }
};


export const getClientToken = () => ({ type: GET_CLIENT_TOKEN });

export const logout = () => {
  const userToken = getUserToken();
  removeUserToken();
  return { type: LOGOUT, payload: userToken.access_token };
};

export const login = data => ({ type: LOGIN, payload: data });

export const externalLogin = () => {
  const token = getUserToken();
  if (token) {
    return { type: EXTERNAL_LOGIN, payload: token };
  }
  return { type: NOT_AUTHORIZED };
};

export const annulUserTokenError = () => ({ type: ANNUL_USER_TOKEN_ERROR });

export const checkAuthorized = () => {
  const userToken = getUserToken();
  if (userToken) {
    return { type: IS_AUTHORIZED, payload: userToken.refresh_token };
  }
  return { type: NOT_AUTHORIZED };
};


export const getClientTokenObservable = () => Observable
  .fromPromise(requestClientTokenAPI())
  .map((data) => {
    setClientToken(data);
    return { type: GET_CLIENT_TOKEN_SUCCESS, payload: data };
  })
  .catch(err => Observable.of({ type: GET_CLIENT_TOKEN_ERROR, payload: err }));

export const loginObservable = (store, requestData) => Observable
  .fromPromise(loginAPI(requestData))
  .map(({ data }) => {
    setUserToken(data);
    return { type: LOGIN_SUCCESS, payload: data };
  })
  .catch(err => Observable.of({ type: LOGIN_ERROR, payload: err }));

export const checkAuthorizedObservable = (store, requestData) => Observable
  .fromPromise(refreshTokenAPI(requestData))
  .map(({ data }) => {
    setUserToken(data);
    return { type: IS_AUTHORIZED_SUCCESS, payload: data };
  })
  .catch(err => Observable.of({ type: NOT_AUTHORIZED, payload: err }));

export const logoutObservable = (store, requestData) => Observable
  .fromPromise(logoutAPI(requestData))
  .map(({ data }) => ({ type: LOGOUT_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: LOGOUT_ERROR, payload: err }));

/*
  Epics
*/

export const getClientTokenEpic = (action$, store) => action$
  .ofType(GET_CLIENT_TOKEN)
  .flatMap(action => getClientTokenObservable(store, action.payload));

export const loginEpic = (action$, store) => action$
  .ofType(LOGIN)
  .flatMap(action => loginObservable(store, action.payload));

export const checkAuthorizedEpic = (action$, store) => action$
  .ofType(IS_AUTHORIZED)
  .flatMap(action => checkAuthorizedObservable(store, action.payload));

export const logoutEpic = (action$, store) => action$
  .ofType(LOGOUT)
  .flatMap(action => logoutObservable(store, action.payload));

export const oauthEpic = combineEpics(
  getClientTokenEpic,
  loginEpic,
  checkAuthorizedEpic,
  logoutEpic,
);



// WEBPACK FOOTER //
// ./src/reducers/oauth/duck.js